import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ErroApi } from '../api/cliente';

/** Carregando / erro / conteúdo. 503 de métrica sem coluna vira aviso explicado, não "erro". */
export function Estado<T>({ consulta, children }: { consulta: UseQueryResult<T>; children: (dados: T) => ReactNode }) {
  if (consulta.data !== undefined) {
    return <div className={consulta.isPlaceholderData ? 'atualizando' : undefined}>{children(consulta.data)}</div>;
  }
  if (consulta.isError) {
    const e = consulta.error;
    if (e instanceof ErroApi && e.status === 503) {
      return (
        <div className="aviso" role="status">
          <strong>Ainda sem dados para esta seção.</strong>
          <p>{e.message}</p>
          {e.detalhe && <p className="mudo">Falta: {e.detalhe}</p>}
        </div>
      );
    }
    return (
      <div className="aviso erro" role="alert">
        <strong>Não consegui carregar.</strong>
        <p>{e instanceof Error ? e.message : String(e)}</p>
        <button type="button" onClick={() => void consulta.refetch()}>
          Tentar de novo
        </button>
      </div>
    );
  }
  return <div className="carregando" aria-busy="true">Carregando…</div>;
}
